import React from 'react'
import { CircleLoader, P, Div } from '@drifthq/tide-core'

import './style.css'

const VideoLandingStep = () => {
  return (
    <Div className="video-landing">
      <CircleLoader size="large" className="video-landing-loader"/>
      <P>Getting everything set up...</P>
    </Div>
  )
}

export default VideoLandingStep



// WEBPACK FOOTER //
// ./src/layouts/VideoLandingStep/component.js